import Disclaimers from './Disclaimers';

export default Disclaimers;